module.exports = __webpack_public_path__ + "img/homeTour.8b05517d.png";